var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["PRIMARY"] = "primary";
  ButtonType2["SECONDARY"] = "secondary";
  ButtonType2["SECONDARY_INVERSE"] = "secondary-inverse";
  ButtonType2["GHOST"] = "ghost";
  ButtonType2["GHOST_INVERSE"] = "ghost-inverse";
  ButtonType2["DANGER"] = "danger";
  ButtonType2["AGENT"] = "agent";
  ButtonType2["TERTIARY"] = "tertiary";
  ButtonType2["TERTIARY_AGENT"] = "tertiary-agent";
  ButtonType2["TERTIARY_DANGER"] = "tertiary-danger";
  ButtonType2["TERTIARY_NEUTRAL"] = "tertiary-neutral";
  ButtonType2["TERTIARY_WHITE"] = "tertiary-white";
  return ButtonType2;
})(ButtonType || {});
var ButtonElement = /* @__PURE__ */ ((ButtonElement2) => {
  ButtonElement2["A"] = "a";
  ButtonElement2["BUTTON"] = "button";
  return ButtonElement2;
})(ButtonElement || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["SMALL"] = "small";
  ButtonSize2["MEDIUM"] = "medium";
  ButtonSize2["LARGE"] = "large";
  ButtonSize2["XL"] = "xl";
  return ButtonSize2;
})(ButtonSize || {});
const WsButtonEnum = {
  Type: ButtonType,
  Element: ButtonElement,
  Size: ButtonSize
};
export {
  ButtonElement,
  ButtonSize,
  ButtonType,
  WsButtonEnum,
  WsButtonEnum as default
};
//# sourceMappingURL=WsButton.enum.es.js.map
